import styled from '@emotion/styled';
import '../../../assets/colors.scss';
const NavbarQuoteDetailStyle = styled('div')`
    .card {
        background-color: rgb(255, 255, 255);
        flex-shrink: 0;
        border-radius: 8px;
        box-shadow: rgba(156, 171, 194, 0.4) 4px 4px 20px 0px;
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .box-consultant {
        font-size: 14px;

        .consultant {
            width: 60%;
        }

        p {
            margin-bottom: 5px;
        }
        .golfer {
            color: rgb(69, 69, 69);
            font-size: 16px;
            font-weight: 700;
            margin-top: 16px;
        }
        .email {
            color: rgb(18, 184, 151);
            text-decoration-line: underline;
        }
        .box-right {
            font-weight: 900;
            color: #454545;
            text-align: right;
            margin-top: 5px;
        }
    }

    .btn-pay {
        background-color: rgb(18, 184, 151) !important;
        width: 100%;
        height: 56px;
        font-weight: 900;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        color: #fff;
        margin: 12px 0 4px;
    }

    .btnShare {
        width: 100%;
        height: 56px;
        color: rgb(18, 184, 151) !important;
        border-color: rgb(18, 184, 151) !important;
        font-weight: 900;
        font-size: 16px;
    }

    .navbar {
        font-size: 16px;
        font-weight: 700;
        li {
            padding: 3px 0;
            a {
                line-height: 24px;
                text-decoration-line: underline;
                color: rgb(26, 145, 255);
                display: flex;
                align-items: center;
                gap: 6px;
                &:hover {
                    transform: scale(1.05);
                }
                &.active {
                    color: #000;
                    text-decoration-line: none;
                    transform: scale(1);
                }
            }
        }
    }

    .mini-basket {
        .reference {
            margin: -1rem -1rem 1rem;
            background: #f2fffa;
            text-align: center;
            padding: 10px 0;
            border-radius: 8px 8px 0 0;
            font-weight: 600;
        }
    }

    .best-price {
        background: #f0fffe;
        color: #000;
        font-size: 14px;
        line-height: 1.4;
        .img {
            min-width: 103px;
        }
        .title {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: 700;
        }
    }

    .loyalty {
        background: #152643;
        color: #fff;
        font-size: 14px;
        line-height: 1.4;
        .img {
            min-width: 103px;
            padding-top: 5px;
        }
        .title {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: 700;
        }
        a {
            color: rgb(26, 145, 255);
            text-decoration-line: underline;
        }
    }

    .lifetime {
        line-height: 1.4;
        .header {
            font-weight: 700;
            margin-bottom: 6px;
        }

        .input {
            height: 40px;
            padding: 5px;
            border: 2px solid rgb(18, 184, 151);
            font-size: inherit;
            font-weight: 900;
            border-radius: 0;
            margin-top: 10px;
            &.ant-input-status-error {
                border-color: #ff4d4f;
            }
        }
    }

    @media screen and (min-width: 1200px) {
        .best-price {
            .title {
                max-width: 185px;
            }
        }
    }

    @media print {
        .card {
            border: 1px solid rgb(220, 220, 220);
            box-shadow: none;
        }
    }
`;
export default NavbarQuoteDetailStyle;
